import { render, staticRenderFns } from "./AddNewInvoice.vue?vue&type=template&id=3c1ddf66&scoped=true&"
import script from "./AddNewInvoice.vue?vue&type=script&lang=js&"
export * from "./AddNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddNewInvoice.vue?vue&type=style&index=0&id=3c1ddf66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ddf66",
  null
  
)

export default component.exports